import { Pie } from "@antv/g2plot";
import {
  Avatar,
  Card,
  Col,
  Form,
  Row,
  Space,
  Spin,
  Tabs,
  Typography,
} from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { showCheckerApprovalModal } from "../../components/CheckerModal";
import MainLayout from "../../components/layouts/enhancement/MainLayout";
import TopContent from "../../components/layouts/enhancement/TopContent";
import { rightAction } from "../../redux/actions";
import cnt from "../../services/definedConstant";
import { BOM } from "../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "./serviceProvider.config";
import ContactInfo from "./tabs/ContactInfo";
import General from "./tabs/General";
import Others from "./tabs/Others";

import dayjs from "dayjs";
import Notiflix from "notiflix";
import { useLocation, useNavigate } from "react-router-dom";
import { handleFlgStatus } from "../../components/facilities/TreasuryFacility";

const { TabPane } = Tabs;

function renderStatistic(
  containerWidth,
  text,
  fontSize = "20px",
  fontWeight = "500",
) {
  const textStyleStr = `width:${containerWidth}px;font-size:${fontSize};font-weight:${fontWeight};`;
  return `<div style="${textStyleStr}">${text}</div>`;
}

const customerData = [
  { type: "Active", value: 45 },
  { type: "Pending", value: 35 },
  { type: "Closed", value: 20 },
];

const walletData = [
  { type: "Wallet 1", value: 45 },
  { type: "Wallet 2", value: 35 },
  { type: "Wallet 3", value: 20 },
];

const containerWidth = 380;
const containerHeight = 350;

const basePieConfig = {
  appendPadding: 0,
  angleField: "value",
  colorField: "type",
  radius: 0.8,
  innerRadius: 0.6,
  width: containerWidth,
  height: containerHeight,
  legend: { position: "right" },
  color: ["#17B26A", "#FDB022", "#667085"],
  label: {
    type: "inner",
    offset: "-50%",
    style: {
      textAlign: "center",
    },
    autoRotate: false,
    content: "{value}",
  },
  // interactions: [
  //   { type: "element-selected" },
  //   { type: "element-active" },
  //   { type: "pie-statistic-active" },
  // ],
};

const customerPieConfig = {
  ...basePieConfig,
  statistic: {
    title: {
      offsetY: -4,
      customHtml: (container, view, datum) => {
        const d = Math.sqrt(
          Math.pow(containerWidth / 2, 2) + Math.pow(containerHeight / 2, 2),
        );
        const text = datum ? datum.type : "Total Customers";
        return renderStatistic(d, text, "14px", "500");
      },
    },
    content: {
      offsetY: 4,
      style: {
        fontSize: "36px",
        fontWeight: "600",
        color: "#101828",
      },
      customHtml: (container, view, datum, data) => {
        const text = datum
          ? `${BOM.formatNumber(datum.value)}`
          : `${data.reduce((r, d) => r + d.value, 0)}`;
        return renderStatistic(containerWidth, text, "36px", "600");
      },
    },
  },
};

const walletPieConfig = {
  ...basePieConfig,
  statistic: {
    title: {
      offsetY: -4,
      customHtml: (container, view, datum) => {
        const d = Math.sqrt(
          Math.pow(containerWidth / 2, 2) + Math.pow(containerHeight / 2, 2),
        );
        const text = datum ? datum.type : "Total Wallet Balance";
        return renderStatistic(d, text, "14px", "500");
      },
    },
    content: {
      offsetY: 4,
      style: {
        fontSize: "36px",
        fontWeight: "600",
        color: "#101828",
      },
      customHtml: (container, view, datum, data) => {
        const text = datum
          ? `${BOM.formatNumber(datum.value)}`
          : `${data.reduce((r, d) => r + d.value, 0)}`;
        return renderStatistic(containerWidth, text, "36px", "600");
      },
    },
  },
};

const DetailServiceProvider = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  console.log(state);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTabKey, setActiveTabKey] = useState("general");
  const [providerData, setProviderData] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [productData, setProductData] = useState([]);
  const customerChartRef = useRef(null);
  const walletChartRef = useRef(null);

  const [form] = Form.useForm();
  const isActive = Form.useWatch("active", form);
  const idType = Form.useWatch("idTypeId", form);
  const openCasa = Form.useWatch("openCasa", form);
  const legalOption = Form.useWatch("legalFormId", form);
  const agentTypeWatch = Form.useWatch("agentType", form);
  const [officeData, setOfficeData] = useState([]);
  const [legalFormData, setLegalFormData] = useState([]);
  const [customerTypeData, setCustomerTypeData] = useState([]);
  const [titleData, setTitleData] = useState([]);
  const [savingsProduct, setSavingsProduct] = useState([]);
  const [legalFormValue, setLegalFormValue] = useState(legalOption);
  const [clientClassificationData, setClientClassificationData] = useState([]);
  const [
    clientNonPersonConstitutionOptions,
    setClientNonPersonConstitutionOptions,
  ] = useState([]);
  const [
    clientNonPersonMainBusinessLineOptions,
    setClientNonPersonMainBusinessLineOptions,
  ] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [countryIdData, setCountryIdData] = useState([]);
  const [addressTypeIdData, setAddressTypeIdData] = useState([]);
  const [stateProvinceIdData, setStateProvinceIdData] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [identifactionTypeData, setIdentificattionTypeData] = useState([]);
  const [addressList, setAddressList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [customerList, setCustomerList] = useState([]);

  const [formData, setFormData] = useState({
    generalInfo: null,
    contactInfo: null,
    othersInfo: null,
    addresses: null,
  });

  const disabledAfterCurrentDate = (current) => {
    return current && current.valueOf() > Date.now();
  };

  const minDate = dayjs().add(0, "day");

  const disableDaysBeforeToday = useCallback(
    (current) => {
      if (current == null) {
        return null;
      }

      return (
        minDate != null &&
        current.isBefore(minDate) &&
        !current.isSame(minDate, "day")
      );
    },
    [minDate],
  );

  const tabList = [
    {
      key: "general",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>General</span>
        </div>
      ),
    },
    {
      key: "contactInfo",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>Contact Info</span>
        </div>
      ),
    },
    {
      key: "others",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>Others</span>
        </div>
      ),
    },
  ];

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };

  useEffect(() => {
    // Render customer position pie chart
    if (customerChartRef.current) {
      const customerChart = new Pie(customerChartRef.current, {
        data: customerData,
        ...customerPieConfig,
      });
      customerChart.render();
      return () => customerChart.destroy();
    }
  }, []);

  useEffect(() => {
    // Render wallet position pie chart
    if (walletChartRef.current) {
      const walletChart = new Pie(walletChartRef.current, {
        data: walletData,
        ...walletPieConfig,
      });
      walletChart.render();
      return () => walletChart.destroy();
    }
  }, []);

  useEffect(() => {
    getTemplate();
    getAddress();
    getProductTemplate();
    getCustomerListAction();
  }, []);

  function getTemplate() {
    const url = `${apiConfig.Clients}/${state.id}?template=true&staffInSelectedOfficeOnly=true`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setProviderData(objDetail);
        console.log(objDetail);

        form.setFieldsValue({
          agentType: objDetail?.agentMerchantData?.agentType,
          superAgentId: objDetail?.agentMerchantData?.superAgentId,
          tradingName: objDetail?.agentMerchantData?.tradingName,
          natureOfBusiness: objDetail?.agentMerchantData?.natureOfBusiness,
          businessRegistrationNumber:
            objDetail?.agentMerchantData?.businessRegistrationNumber,
          taxIdentificationNumber:
            objDetail?.agentMerchantData?.taxIdentificationNumber,
          businessDescription:
            objDetail?.agentMerchantData?.businessDescription,
          legalFormId: objDetail?.legalForm?.id,
          officeId: objDetail?.officeName,
          clientTypeId: objDetail?.clientType?.id,
          fullname: objDetail?.displayName,
          firstname: objDetail?.firstname,
          lastname: objDetail?.lastname,
          emailAddress: objDetail?.emailAddress,
          mobileNo: objDetail?.mobileNo,
          constitutionId: objDetail?.clientNonPersonDetails?.constitution?.id,
          mainBusinessLineId:
            objDetail?.clientNonPersonDetails?.mainBusinessLine?.id,
          accountNo: objDetail?.accountNo,
          active: objDetail?.active,
          isStaff: objDetail?.isStaff,
          riskRating: objDetail?.riskRating,
          pepStatus: objDetail?.pepStatus,
          dateOfBirth: objDetail?.dateOfBirth
            ? dayjs(BOM?.FormatArrayDate(objDetail?.dateOfBirth))
            : objDetail?.dateOfBirth,
          activationDate: objDetail?.timeline?.activatedOnDate
            ? dayjs(BOM?.FormatArrayDate(objDetail?.timeline?.activatedOnDate))
            : objDetail?.timeline?.activatedOnDate,
          submittedOnDate: objDetail?.timeline?.submittedOnDate
            ? dayjs(BOM?.FormatArrayDate(objDetail?.timeline?.submittedOnDate))
            : objDetail?.timeline?.submittedOnDate,
          genderId: objDetail?.gender?.id,
          externalId: objDetail?.externalId,
          staffId: objDetail?.staffId,
          clientClassificationId: objDetail?.clientClassification?.id,
          idTypeId: objDetail?.idType?.id,
          idNumber: objDetail?.idNumber,
          idIssuingDate: objDetail?.idIssuingDate
            ? dayjs(BOM?.FormatArrayDate(objDetail?.idIssuingDate))
            : objDetail?.idIssuingDate,
          passExpDate: objDetail?.passExpDate
            ? dayjs(BOM?.FormatArrayDate(objDetail?.passExpDate))
            : objDetail?.passExpDate,
          savingsProductId: objDetail?.savingsProductId
            ? objDetail?.savingsProductId
            : null,
        });

        let tempOfficeData = [];
        let tempLegalFormData = [];
        let tempCustomerType = [];
        let tempTitle = [];
        let tempCountries = [];
        let tempCountryId = [];
        let tempAddressTypeId = [];
        let tempStateProvinceId = [];
        let tempGender = [];
        let tempIdentification = [];
        let tempClientClassification = [];
        let tempClientNonPersonConstitutionOptions = [];
        let tempClientNonPersonMainBusinessLineOptions = [];
        let tempStaffData = [];
        let tempSavingsProduct = [];

        objDetail?.officeOptions?.forEach((element) => {
          tempOfficeData.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.clientLegalFormOptions?.forEach((element) => {
          tempLegalFormData.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail?.clientTypeOptions?.forEach((element) => {
          tempCustomerType.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.genderOptions?.forEach((element) => {
          tempGender.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.countryOptions?.forEach((element) => {
          tempCountries.push({
            value: element.description,
            label: element.name,
          });
        });

        objDetail?.clientClassificationOptions?.forEach((element) => {
          tempClientClassification.push({
            value: element.id,
            label: element.name,
          });
        });
        objDetail?.clientNonPersonConstitutionOptions?.forEach((element) => {
          tempClientNonPersonConstitutionOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.clientNonPersonMainBusinessLineOptions?.forEach(
          (element) => {
            tempClientNonPersonMainBusinessLineOptions.push({
              value: element.id,
              label: element.name,
            });
          },
        );

        objDetail?.staffOptions?.forEach((element) => {
          tempStaffData.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objDetail?.savingProductOptions
          ?.filter((item) => item.allowOverdraft === false)
          .forEach((element) => {
            tempSavingsProduct.push({
              value: element.id,
              label: element.name ? `${element.name} (${element.id})` : "",
            });
          });

        // objDetail?.savingProductOptions?.forEach((element) => {
        //   tempSavingsProduct.push({
        //     value: element.id,
        //     label: element.name,
        //   });
        // });

        objDetail?.idTypes?.forEach((element) => {
          tempIdentification.push({
            value: element.id,
            label: element.name,
          });
        });

        switch (objDetail?.status.value?.toLowerCase()) {
          case "active":
            BOM.HasPermission("CLOSE_CLIENT") &&
              [cnt.RIGHT_REJECT_BTN].map((items) => {
                dispatch({ type: items });
              });
            break;
          case "pending":
            [cnt.RIGHT_APPROVE_BTN].map((items) => {
              dispatch({ type: items });
            });
            break;
        }

        setOfficeData(tempOfficeData);
        setLegalFormData(tempLegalFormData);
        setCustomerTypeData(tempCustomerType);
        setTitleData(tempTitle);
        setSavingsProduct(tempSavingsProduct);
        // setActivationDate(objDetail?.activationDate);
        setClientClassificationData(tempClientClassification);
        setClientNonPersonConstitutionOptions(
          tempClientNonPersonConstitutionOptions,
        );
        setClientNonPersonMainBusinessLineOptions(
          tempClientNonPersonMainBusinessLineOptions,
        );
        setStaffData(tempStaffData);
        setCountryData(tempCountries);
        setCountryIdData(tempCountryId);
        setAddressTypeIdData(tempAddressTypeId);
        setStateProvinceIdData(tempStateProvinceId);
        setGenderData(tempGender);
        setIdentificattionTypeData(tempIdentification);
        setIsLoading(false);
      }
    });
  }

  function getAddress() {
    const url = `${apiConfig.FieldConfiguration}/address`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        // const objList = res;
        setIsLoading(false);
      }
    });
  }

  const getProductTemplate = () => {
    const url = `${apiConfig.WalletAccount}/template`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        console.log(res);
        let tempProducts = [];

        objList?.walletsProductDataList.forEach((element) => {
          tempProducts.push({
            value: element.savingsProductData.id,
            label: element.savingsProductData.name
              ? `${element.savingsProductData.name} (${element.id})`
              : "",
          });
        });

        setProductData(tempProducts);
      }
    });
  };

  const getCustomerListAction = (offset = 0, limit = 500) => {
    const params = {
      limit: limit,
      offset: offset,
      orderBy: "id",
      agentMerchantOnly: true,
    };

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.Clients, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res.pageItems;

        const filteredItems = objList.filter((item) => {
          const type = item.agentMerchantData?.agentType;
          return ["AGENT", "MERCHANT", "SUPER_AGENT"].includes(type);
        });

        let tempArray = [];

        filteredItems.forEach((element) => {
          const statusValue = element?.status ? element?.status.value : "-";
          tempArray.push({
            key: element?.agentMerchantData?.id,
            id: element?.agentMerchantData?.id,
            name: element?.displayName ? element?.displayName : "-",
            clientno: element?.accountNo ? element?.accountNo : "-",
            mobileNo: element?.mobileNo ? element?.mobileNo : "-",
            status:
              statusValue?.toLowerCase() === "submitted and pending approval"
                ? "Pending"
                : statusValue,
            branch: element?.officeName ? element?.officeName : "-",
            staff: element?.staffName ? element?.staffName : "-",
            branchId: element?.officeId ? element?.officeId : "-",
            agentType: element?.agentMerchantData?.agentType,
          });
        });

        setCustomerList(tempArray);
        setOriginalList(tempArray);
        setIsLoading(false);
      }
    });
  };

  const handleAddressDelete = (key) => {
    // console.log(key);
    let action = "Delete  ";
    let label = key.title;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = addressList.filter((item) => item.id !== key.id);
        setAddressList(newData);
      },

      function () {
        // No button
      },
    );
  };

  const contentListNoTitle = {
    general: (
      <General
        form={form}
        initialValues={formData.generalInfo}
        isCreateScreen={true}
        userData={userData}
        isActive={isActive}
        legalFormData={legalFormData}
        officeData={officeData}
        legalOption={legalOption}
        customerTypeData={customerTypeData}
        genderData={genderData}
        disabledAfterCurrentDate={disabledAfterCurrentDate}
        agentType={agentTypeWatch}
        customerList={customerList}
        disableDaysBeforeToday={disableDaysBeforeToday}
        clientNonPersonMainBusinessLineOptions={
          clientNonPersonMainBusinessLineOptions
        }
        clientNonPersonConstitutionOptions={clientNonPersonConstitutionOptions}
      />
    ),
    contactInfo: (
      <ContactInfo
        initialValues={formData.contactInfo}
        form={form}
        identifactionTypeData={identifactionTypeData}
        legalOption={legalFormValue}
        countryData={countryData}
        idType={idType}
        disabledAfterCurrentDate={disabledAfterCurrentDate}
        disableDaysBeforeToday={disableDaysBeforeToday}
        isLoading={isLoading}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        setAddressList={setAddressList}
        addressList={addressList}
        addressTypeIdData={addressTypeIdData}
        stateProvinceIdData={stateProvinceIdData}
        countryIdData={countryIdData}
        handleAddressDelete={handleAddressDelete}
        // NEW field
        currentCustomerObj={state}
        addressDetails={addressList}
        userData={userData}
      />
    ),
    others: (
      <Others
        initialValues={formData.othersInfo}
        form={form}
        walletProduct={productData}
        openCasa={openCasa}
        clientClassificationData={clientClassificationData}
        staffData={staffData}
      />
    ),
  };

  function handleOnActivateClose() {
    const status = providerData?.status?.value?.toLowerCase();
    const agentCode =
      providerData?.agentMerchantData?.agentCode || state?.agentId;

    if (status === "active") {
      Notiflix.Confirm.show(
        "Are you sure?",
        `Deactivate ${agentCode}`,
        "Yes",
        "No",
        function () {
          setIsLoading(true);
          const params = { command: "deactivate" };
          const deactivationDate = dayjs().format("DD MMMM YYYY");

          const body = {
            method: "POST",
            session,
            params,
            deactivationDate,
            dateFormat: "dd MMMM yyyy",
            locale: "en",
          };

          BOM.FetchReqAction(
            body,
            `${apiConfig.Clients}/${state.id}`,
            (err, res) => {
              if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
              } else {
                BOM.AlertMsg(
                  cnt.SUCCESS,
                  labelConfig.activateServiceProviderMsg,
                );
                navigate("/service-provider");
                setIsLoading(false);
              }
            },
            {
              navigate,
              showCheckerModal: showCheckerApprovalModal,
              onCheckerApproval: () => {
                navigate("/service-provider");
                setIsLoading(false);
              },
            },
          );
        },
        function () {},
      );
    } else {
      Notiflix.Confirm.show(
        "Are you sure?",
        `Activate ${agentCode}`,
        "Yes",
        "No",
        function () {
          setIsLoading(true);
          const params = { command: "activate" };
          const activationDate = dayjs().format("DD MMMM YYYY");

          const body = {
            method: "POST",
            session,
            params,
            activationDate,
            dateFormat: "dd MMMM yyyy",
            locale: "en",
          };

          BOM.FetchReqAction(
            body,
            `${apiConfig.Clients}/${state.id}`,
            (err, res) => {
              if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
              } else {
                BOM.AlertMsg(
                  cnt.SUCCESS,
                  labelConfig.activateServiceProviderMsg,
                );
                navigate("/service-provider");
                setIsLoading(false);
              }
            },
            {
              navigate,
              showCheckerModal: showCheckerApprovalModal,
              onCheckerApproval: () => {
                navigate("/service-provider");
                setIsLoading(false);
              },
            },
          );
        },
        function () {},
      );
    }
  }

  return (
    <MainLayout
      pageItems={staticConfig.detailBreadcrumbItems}
      isEnableRightSidebar={true}
      onApprove={() => handleOnActivateClose()}
      onReject={() => handleOnActivateClose()}
    >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.detailServiceProvider}
        pageItems={staticConfig.detailServiceProvider}
      />

      <Spin spinning={isLoading} size="large">
        {/* Header: avatar, name, status, branch button */}
        <Row align="middle" style={{ marginTop: 24, marginBottom: 24 }}>
          <Col span={16}>
            <Space align="center">
              <Avatar
                size={64}
                src={null}
                style={{ backgroundColor: "#f56a00" }}
              >
                {providerData?.displayName?.charAt(0) || "-"}
              </Avatar>
              <div>
                <Typography.Title level={4} style={{ margin: 0 }}>
                  {providerData?.displayName || "-"}
                </Typography.Title>
                <div style={{ color: "#8c8c8c" }}>
                  Agent Code:{" "}
                  {providerData?.agentMerchantData?.agentCode || "-"}
                </div>
              </div>
              <div>
                {providerData?.status
                  ? handleFlgStatus(
                      providerData?.status?.value,
                      {
                        padding: "2px 12px",
                        borderRadius: "16px",
                        fontSize: "12px",
                        fontWeight: 500,
                        display: "inline-block",
                        textTransform: "capitalize",
                      },
                      false,
                    )
                  : "-"}
              </div>
            </Space>
          </Col>
          <Col span={8} style={{ textAlign: "right" }}>
            <div style={{ marginBottom: 8, color: "#8c8c8c" }}>
              Branch name: <strong>{providerData?.officeName || "-"}</strong>
            </div>
          </Col>
        </Row>
        {/* Customer / Wallet Section */}
        <Row gutter={24}>
          <Col span={12}>
            <Card title="Agent Customers">
              <div ref={customerChartRef} />
            </Card>
          </Col>
          <Col span={12}>
            <Card title="Agent Wallets">
              <div ref={walletChartRef} />
            </Card>
          </Col>
        </Row>

        <Card
          className="custom-transaction-tab"
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            width: "100%",
            // boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 24,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DetailServiceProvider);
